import React, { useEffect, useState } from 'react';
import '../../assets/css/VerifyPassword.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
const VerifyOTP = () => {
    const {setToken}=useAuth();
    const [firstVal, setFirstVal] = useState()
    const [secondVal, setSecondVal] = useState()
    const [thirdVal, setThirdVal] = useState()
    const [forthVal, setForthVal] = useState()
    const [email, setEmail] = useState()
    const navigate = useNavigate()

    const location = useLocation()
    useEffect(() => {
        if (location) {
            setEmail(location.state.email)
        }
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (firstVal && secondVal && thirdVal && forthVal) {
            const obj = {
                email,
                code: `${firstVal}${secondVal}${thirdVal}${forthVal}`
            }
            new WebApiCalls().userOtpVerification(obj)
                .then(res => {
                    if (res?.code === 200) {
                        toast.success(res?.desc);
                        navigate('/change-password', { state: { email, token: res?.token } });
                    }
                    else {
                        toast.error("Oops...! Something went wrong...");
                    }
                })
                .catch(err => { })
        }
    }

    const handleResendOtp=async()=>{
        new WebApiCalls().resendOtp({email})
        .then(res=>{
            if(res?.code===200){
                toast.success(res?.desc)
            }else{
                toast.error("Oops...! Something went wrong...");
            }
        })
    }

    return (
        <Container fluid>
            <Row className="justify-content-center align-items-center">
                {/* Image section */}
                <Col className="px-0">
                    <div className="forget-bg2">
                        <div className="f-header">
                            <p>All Public</p>
                            <p>Transit across</p>
                            <span>Canada</span>
                        </div>
                    </div>
                </Col>
                {/* Input Section */}
                <Col>
                    <Form onSubmit={handleSubmit}>
                        <div className="forget-pass-wrapper mx-auto w-50">
                            <div className="forget-title mb-5">
                                <p>
                                    Please Enter
                                    <br />
                                    <strong>Verification Code!</strong>
                                </p>
                            </div>
                            <div className="mb-5">
                                <Row>
                                    <Col className="d-flex justify-content-around">
                                        <Form.Control value={firstVal} className='verify-passcode-input text-center' bsPrefix="input-code" type="number" max={9} min={0}
                                            onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 1) }}
                                            onChange={e => setFirstVal(e.target.value)}
                                            required />

                                        <Form.Control value={secondVal} className='verify-passcode-input' bsPrefix="input-code" type="number" max={9} min={0}
                                            onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 1) }}
                                            onChange={e => setSecondVal(e.target.value)} required />

                                        <Form.Control value={thirdVal} className='verify-passcode-input' bsPrefix="input-code" type="number" max={9} min={0}
                                            onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 1) }}
                                            onChange={e => setThirdVal(e.target.value)} required />

                                        <Form.Control value={forthVal} className='verify-passcode-input' bsPrefix="input-code" type="number" max={9} min={0}
                                            onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 1) }}
                                            onChange={e => setForthVal(e.target.value)} required />
                                        </Col>
                                </Row>
                            </div>
                            {/* Send Button */}
                            <div className="text-center">
                                <Button type="submit" bsPrefix="code-btn" variant="primary" size="lg">
                                    SUBMIT
                                </Button>
                                <p className='send-again mt-2'>
                                    Don't receive the code? <strong onClick={handleResendOtp}>SEND AGAIN</strong>
                                </p>
                            </div>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default VerifyOTP;
